<template>
    <div :class="['text-response', {'is-multi' : isMulti}]" style="padding-top: 9px;">
        <span v-if="response != null && response[0] && response[0].year" class="sign-and-date answer">
            {{getMonth(response[0].month)}} {{ response[0].date ? getDateFormat(response[0].date) : ''}}, {{response[0].year}}
        </span>
        <div v-else class="no-answer">
            <span>Not Answered</span>
        </div>
    </div>
</template>

<script>

import formatDateTime from '@/module/util/format-date-time'

export default {   
    name: 'date-partial',

    props: {
		response: {
			type: Array,
            default: () => [],
		},
        isMulti: {
            type: Boolean
        }
    },
    
    methods: {
        formatDateTime,
        getDateFormat(date) {
            if(date < 9) {
                return '0' + date
            }
            return date
        },
        getMonth(month) {
            const monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
            return monthNames[month - 1]
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.text-response.is-multi {
    padding-top: 2px !important;
    .sign-and-date {
        background-color: #ffffff;
        border: none;
    }
}
</style>
